import { sanitizeUrlsInText } from '@/utils/redaction/sanitize-url'

interface ErrorText {
  message?: string
  stack?: string
  causes?: { message: string; stack?: string }[]
}

export function redactErrorText(error: ErrorText): void {
  if (error.message !== undefined) {
    error.message = sanitizeUrlsInText(error.message)
  }
  if (error.stack !== undefined) {
    error.stack = sanitizeUrlsInText(error.stack)
  }
  for (const cause of error.causes ?? []) {
    redactErrorText(cause)
  }
}
